import { useEffect } from 'react';
import { basic, validationMessages } from '../../../config/validations';
import { useForm } from "react-hook-form";
import { Grid, TextField } from '@material-ui/core';
import NextCancel from '../../atoms/buttons/NextCancel';
import UpdateCancel from '../../atoms/buttons/UpdateCancel';
import { useDispatch } from 'react-redux';
import { handleSnackBar, invokePostService, setReRender } from '../../../store/global/actions';
import { validateNonAsciiChars } from '../../../utils/commonUtils';




export default function CreateTestcase({ onClose,type,testcaseId,testcaseData, isFetching, setIsFetching,  setTestcaseData, errorProps, setOpenTab }) {
    const dispatch = useDispatch();
    const { register, handleSubmit, formState: { errors }, setValue, setError } = useForm({defaultValues: {
        name: testcaseData?.name || '',
        description: testcaseData?.description || ''
    }});
    console.log({testcaseData},'abcd');

    const messages = {
        ...validationMessages,
    }

    const onSimulationNext = async ({ name, description }) => {
        
        if(!validateTestcase(name)) return false

        setOpenTab(prev => prev + 1)

        setTestcaseData({name, description})
    }

    const validateTestcase = (name) => {
        if(!name){
            setError('name',{
                types: 'error',
                message: 'Name field is required',
                shouldFocus: 'name'
            })
            return false
        }
        return true
    }

    const onTestcaseUpdate = async ({name, description}) => {
        if(!validateTestcase(name)) return false
        setIsFetching(true)
        dispatch(invokePostService('updateTestcaseBasicDetails', {name, description}, [testcaseId]))
            .then((response) => {
                setIsFetching(false)
                if(response.status && response.data){
                    setTestcaseData(prev => ({
                        ...prev,
                        name: response?.data?.name,
                        description: response?.data?.description
                    }))
                    dispatch(setReRender())
                    dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }))
                    return true
                }
                dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }))
            })
    }


    useEffect(() => {
        if(errorProps){
            setError(errorProps?.name, {type: 'custom', message: errorProps?.message})
        }
    },[errorProps])

    useEffect(() => {
        setValue('name', testcaseData?.name || '')
        setValue('description', testcaseData?.description || '')
    },[testcaseData])

    return (
        <Grid container direction={"row"} spacing={3}>
            
            <Grid item xs={12}>
                <TextField
                    name="name"
                    id="name"
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Name"}
                    variant="outlined"
                    placeholder={""}
                    inputRef={register({ ...basic })}
                    error={errors?.name ? true : false}
                    InputLabelProps={{ shrink: true }}
                    // helperText={errors?.name ? messages[errors?.name?.type] : ''}
                    helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    type={"text"}
                    fullWidth
                    multiline={true}
                    rows={4}
                    label={"Description"}
                    variant="outlined"
                    name="description"
                    InputLabelProps={{ shrink: true }}
                    inputRef={register({ required: false, validate: validateNonAsciiChars })}
                    error={errors?.description}
                    helperText={errors?.description?.message || ''}
                />
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                {
                    type === "edit"? 
                    <UpdateCancel onUpdate={handleSubmit(onTestcaseUpdate)} onCancel={onClose} updateDisable={isFetching}/> :
                    <NextCancel onNext={handleSubmit(onSimulationNext)} onCancel={onClose} disableNext={isFetching} content={'Next'} />
                }
            </Grid>

        </Grid >
    )
}